export const getIssuesData = (issues) => {
  var Open = 0;
  var InProgress = 0;
  var Pending = 0;
  var Closed = 0;

  issues.forEach((issue) => {
    if (issue.hasOwnProperty("Status")) {
      if (issue["Status"].includes("Closed")) {
        Closed += 1;
      } else if (issue["Status"] === "In Progress") {
        InProgress += 1;
      } else if (issue["Status"] === "Pending Review") {
        Pending += 1;
      } else if (issue["Status"] === "Open") {
        Open += 1;
      }
    }
  });

  return [
    { order: 1, name: `Open (${Open})`, value: Open, color: "#349fda" },
    {
      order: 2,
      name: `In Progress (${InProgress})`,
      value: InProgress,
      color: "#fdd835",
    },
    {
      order: 3,
      name: `Pending (${Pending})`,
      value: Pending,
      color: "#ff9800",
    },
    { order: 4, name: `Closed (${Closed})`, value: Closed, color: "#50C878" },
  ];
};
